module.exports = __webpack_public_path__ + "img/catharina-maria-bugge-l.a50235e9.webp";